import { render, staticRenderFns } from "./BoletoPage.vue?vue&type=template&id=50ae2fed"
import script from "./BoletoPage.vue?vue&type=script&lang=js"
export * from "./BoletoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports